import React from "react";
import Beach from "../../Admin/Question/View/Background/Beach";
import List from "./TrackList";

class Games extends React.Component {
    render() {
        return <List {...this.props} typeOfList="Games" defaultIndexValue={3} Background={<Beach />} Link="/Games/" typeOfLesson="Games" typeOfTree="Fun" Icon="fal fa-gamepad-alt" />;
    }
}
export default Games;